import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { PreloadAllModules, provideRouter, withPreloading } from "@angular/router";
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MsalInterceptor, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService } from "@azure/msal-angular";
import { PublicClientApplication } from "@azure/msal-browser";
import Hotjar from "@hotjar/browser";
import { provideToastr } from "ngx-toastr";
import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";
import { msalInstanceFactory } from "./app/common/msal/msal-instance-factory";
import { msalGuardConfigFactory } from "./app/common/msal/msal-guard-config-factory";
import { msalInterceptorConfigFactory } from "./app/common/msal/msal-interceptor-config-factory";
if (environment.production) {
  enableProdMode();
}

if (environment.hotjarSiteId) {
  Hotjar.init(environment.hotjarSiteId, 6);
}

if (environment.testing) {
  MsalInterceptor.prototype.intercept = (req, next) => {
    // Generating a fake JWT token with the mocked user

    const header = {
      "alg": "HS256",
      "typ": "JWT"
    }
    const encodedHeaders = btoa(JSON.stringify(header));

    let userMocked = localStorage.getItem("userMocked");

    const claims = {
      "unique_name": JSON.parse(userMocked).username
    }

    let encodedPayload = btoa(JSON.stringify(claims));

    // Magic code to remove a failed encoding
    if (encodedPayload.endsWith("==")) encodedPayload = encodedPayload.slice(0, encodedPayload.length - 2);
    else if (encodedPayload.endsWith("=")) encodedPayload = encodedPayload.slice(0, encodedPayload.length - 1);

    const encodedSignature = btoa("not_implemented");

    let jwt = `${encodedHeaders}.${encodedPayload}.${encodedSignature}`;

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${jwt}`
      }
    });
    return next.handle(req);
  };

  PublicClientApplication.prototype.getAllAccounts = (): any => {
    if (!localStorage.getItem('userMocked')) return undefined;

    let user = localStorage.getItem('userMocked');
    return [
      JSON.parse(user)
    ]
  };
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideToastr({ positionClass: "toast-bottom-left" }),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: msalInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: msalGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: msalInterceptorConfigFactory,
        },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: { dateInput: "DD/MM/YYYY" },
                display: {
                    dateInput: "DD/MM/YYYY",
                    monthYearLabel: "MMMM YYYY",
                    dateA11yLabel: "DD/MM/YYYY",
                    monthYearA11yLabel: "MMMM YYYY",
                },
            },
        },
        { provide: MatDialogRef, useValue: {} },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        provideAnimations(),
    ]
})
  .catch((err) => console.error(err));
